// window.onbeforeunload = function() {
//   var is_modal_show = localStorage.getItem('alreadyShow');
//   localStorage.removeItem('alreadyShow');
// };
// $(window).load(function() {
//     setTimeout(function(){
//   $("#itoris_dynamicproductoptions_popup").remove();

//       }, 2000);
// });

// happy customer section on the product page below the product images

$(document).ready(function () {
  $('[data-fancybox="happy"]').fancybox({
    buttons: ["share", "close"],
    loop: false,
    protect: true,
  });
});

$(document).ready(function ($) {
  $("#getVideoModel").hide();
  $("#getVideo").click(function () {
    $("#getVideoModel").show();
    let video = $("#setup_video").val();
    $("#getVideoModel video source").attr("src", video);
    let media = $("#getVideoModel video").get(0);
    media.play();
  });

  $("#close_video").click(function () {
    $("#getVideoModel").hide();
  });

  $("#close").on("click", function () {
    $("#multiple-designs").hide();
  });

  setTimeout(function () {
    var title = $("#productSelect option:selected").html();
    $(".pitchprint_design img").each(function () {
      var curSrc = $(this).attr("src");
      $(this).attr("data-src", curSrc).addClass("lazy2");
      $(this).attr("alt", title);
      $(this).removeAttr("src");
    });
    var img_url = $(".pitchprint_design img").attr("src");
    $(".pitchprint_design img").attr("data-src", img_url).addClass("lazy2");
  }, 2000);
  var initProducts = function (domElement) {
    if (domElement.length === 0) {
      return;
    }

    if (domElement.attr("data-use-recommendations") === "true") {
      var url =
        "/recommendations/products?section_id=product-recommendations&limit=4&product_id=" +
        domElement.attr("data-product-id");
      $.ajax(url).then(function (content) {
        domElement.find(".grid").html($(content).find(".grid").contents());
      });
    }
  };

  initProducts($(".product-recommendations"));

  document.addEventListener("shopify:section:load", function (event) {
    initProducts($(event.target).find(".product-recommendations"));
  });

  var custom_size_box = $("#hidden_meta_size_custom").val();
  //   var galleryThumbs = new Swiper('.gallery-thumbs', {
  //     spaceBetween: 10,
  //     slidesPerView: 6,
  // });

  $("#star-rating").on("click", function () {
    $("#reviews-tab-btn").trigger("click");
    $("html, body").animate(
      { scrollTop: $("#tab_border").offset().top - 150 },
      1000
    );
  });

  $(document).on("click", "#edit_design_now_btn", function (e) {
    e.preventDefault(true);
    $("#pp_edit_btn").trigger("click");
  });
  $("#upload_design_now_btn").on("click", function () {
    $(this).addClass("hidden");
    $("#upload_section").removeClass("hide");
    $(".add_to_cartbtn").removeClass("hide");
    $("#pp-designs-section").addClass("hide");
    $("html, body").animate(
      { scrollTop: $("#upload_section").offset().top },
      1000
    );
  });

  window.UploadKit = window.UploadKit || {};
  window.UploadKit.callbacks = window.UploadKit.callbacks || {};

  window.UploadKit.callbacks.afterFileUploaded = function (data) {
    console.log("afterFileUploaded");
    $(".uploadkit-sketch-image").addClass("hide");
    $("#upload--instructions span:not(.fa)").addClass("hide");
    if (
      $("#require_design_services_hidden").val() == "Let us design one for you"
    ) {
      $(".uploadkit-field").addClass("invisible");
    }
  };

  window.UploadKit.callbacks.afterRefresh = function (data) {
    $(document).on("click", "#design_assist", function () {
      if (data.uploader.files.length > 0) {
        data.uploader.fileObject = null;
        data.uploader.files = [];
        UploadKit.refreshUploader(data.uploader);
      }
    });
    $(document).on("click", "#design_exist", function () {
      if (data.uploader.files.length > 0) {
        data.uploader.fileObject = null;
        data.uploader.files = [];
        UploadKit.refreshUploader(data.uploader);
      }
    });
    if ($(".uploadkit-thumbnails").length > 0) {
      $("#continue_cart").removeClass("hide");
      $("#upload-files-button").addClass("button_gray_active");
    } else {
      $("#continue_cart").addClass("hide");
      $("#upload-files-button").removeClass("button_gray_active");
    }
    $("#continue_cart")
      .closest(".option-content-wrapper")
      .addClass("active-container");
  };

  $(document).on("click", ".uploadkit-thumbnails", function () {
    $(".uploadkit-button").trigger("click");
  });
  let widthSelector = "#standardized_width_" + $("#productSelect").val();
  let widthVal = $(widthSelector).val();
  if (widthVal != undefined) {
    $("#hidden_property_standardized_width").val(widthVal);
  }
  let widthSelector2 =
    "#standardized_width_external_" + $("#productSelect").val();
  let widthVal2 = $(widthSelector2).val();
  if (widthVal2 != undefined) {
    $("#hidden_property_standardized_width_external").val(widthVal2);
  }
  let heightSelector = "#standardized_height_" + $("#productSelect").val();
  let heightVal = $(heightSelector).val();
  if (heightVal != undefined) {
    $("#hidden_property_standardized_height").val(heightVal);
  }

  let sidedSelector = "#standardized_sided_" + $("#productSelect").val();
  let sidedVal = $(sidedSelector).val();
  if (sidedVal != undefined) {
    $("#hidden_property_standardized_sided").val(sidedVal);
  } else {
    $("#hidden_property_standardized_sided").val("Single");
  }

  let materialSelector = "#standardized_material_" + $("#productSelect").val();
  let materialVal = $(materialSelector).val();
  if (materialVal != undefined) {
    $("#hidden_property_standardized_material").val(materialVal);
  }

  let rollSizeSelector = "#standardized_roll_size_" + $("#productSelect").val();
  let rollSizeVal = $(rollSizeSelector).val();
  if (rollSizeVal != undefined) {
    $("#hidden_property_standardized_roll_size").val(rollSizeVal);
  }
  $("#continue_cart").on("click", function () {
    $(this).prop("disabled", true);
    $(this).siblings("svg").attr("class", "loading-svg");
    add_to_cart();
  });

  let product1 = null;

  let coriflute_id = $("#coriflute_id").val();
  $(document).on("click", "#upload-files-button", function (e) {
    $(
      '.uploadkit-button[data-uploader-id="766b430d-b8d5-48b4-84b3-4429c66ad77a"]'
    ).trigger("click");
  });

  $(document).on("click", "#upload-final-artwork-button", function (e) {
    $(
      '.uploadkit-button[data-uploader-id="0b0f6977-e540-48e5-a747-da977cac0464"]'
    ).trigger("click");
  });

  // other product page upload file
  $(document).on("click", ".requiredesignstep .option", function (e) {
    // alert("hello");
    e.preventDefault(true);
    $(this).siblings().removeClass("clicked");
    $(this).addClass("clicked");
    $(".optional-workflow-section").removeClass("activesection");
    $(".optional-workflow-section").addClass("hide");
    if ($(this).attr("id") == "design_exist") {
      // alert("hello");
      console.log("exist");
      $("#require_design_services_hidden").val("Upload a finished artwork");
      $("#pitchprint_custom_design").val("exist");
      $("#upload_section").addClass("activesection");
      if ($(".view_pp_templates").hasClass("clicked")) {
        $("#upload_section").removeClass("hide");
      }

      $(".design__upload").removeClass("hidden");
      $(".design__assist").addClass("hidden");
      $("#upload-files-button").removeClass("hidden");
      $("#upload-final-artwork-button").addClass("hidden");
      if ($(".uploadkit-thumbnails").children().length > 0) {
        $("#continue_cart").removeClass("hide");
      } else {
        $("#continue_cart").addClass("hide");
        $(".uploadkit-sketch-image").removeClass("hide");
      }
      $(".dpo_meeting_option .no input").prop("checked", true);
      $(".dpo_meeting_option .no input").trigger("change");
      $("#numberofdesignsdropdown").prop("disabled", false);
      $(".price_per_design_dpo .exist input").prop("checked", true);
      $(".price_per_design_dpo .exist input").trigger("change");
      if (!isNaN(parseInt($("#numberofdesignsdropdown").val()))) {
        $('.price_per_design_dpo .exist input[type="number"]').val(
          $("#numberofdesignsdropdown").val()
        );
      } else {
        $('.price_per_design_dpo .exist input[type="number"]').val(1);
      }

      $(".uploadkit-field").removeClass("invisible");
      if ($(".quantity__input").val() > 1) {
        $(".numberofdesignstep").removeClass("invisible");
      }
      $(".booking-section").addClass("hide");
    } else if ($(this).attr("id") == "design_own_option") {
      console.log("own");
      $("#require_design_services_hidden").val("Online design from templates");
      $("#pitchprint_custom_design").val("true");
      $("#pp-designs-section").addClass("activesection");
      if ($(".view_pp_templates").hasClass("clicked")) {
        $("#pp-designs-section").removeClass("hide");
      }
      $(".dpo_meeting_option .no input").prop("checked", true);
      $(".dpo_meeting_option .no input").trigger("change");
      $("#numberofdesignsdropdown").val(1);
      $("#numberofdesignsdropdown").prop("disabled", true);

      $(".price_per_design_dpo .own input").prop("checked", true);
      $(".price_per_design_dpo .own input").trigger("change");
      if (!isNaN(parseInt($("#numberofdesignsdropdown").val()))) {
        $('.price_per_design_dpo .own input[type="number"]').val(
          $("#numberofdesignsdropdown").val()
        );
      } else {
        $('.price_per_design_dpo .own input[type="number"]').val(1);
      }

      $(".numberofdesignstep").addClass("invisible");
    } else if ($(this).attr("id") == "design_assist") {
      $(".design__upload").addClass("hidden");
      $("#upload-files-button").addClass("hidden");
      $(".design__assist").removeClass("hidden");
      $("#upload-final-artwork-button").removeClass("hidden");

      $("#require_design_services_hidden").val("Let us design one for you");
      $("#pitchprint_custom_design").val("false");

      $(".uploadkit-sketch-image").addClass("hide");
      $(".design__idea").removeClass("hide");
      $("#upload_section").addClass("activesection");
      if ($(".view_pp_templates").hasClass("clicked")) {
        $("#upload_section").removeClass("hide");
      }
      if ($("#design-idea-textarea").val() != "") {
        $("#upload--instructions span").addClass("hide");
        $("#continue_cart").removeClass("hide");
        $("#numberofdesignsdropdown").prop("disabled", false);
      } else {
        $("#numberofdesignsdropdown").prop("disabled", false);
        $("#continue_cart").addClass("hide");
        $("#upload--instructions span").removeClass("hide");
      }
      $(".dpo_meeting_option .yes input").prop("checked", true);
      $(".dpo_meeting_option .yes input").trigger("change");

      $(".uploadkit-field").addClass("invisible");
      $(".price_per_design_dpo .assist input").prop("checked", true);
      $(".price_per_design_dpo .assist input").trigger("change");
      if (!isNaN(parseInt($("#numberofdesignsdropdown").val()))) {
        $('.price_per_design_dpo .assist input[type="number"]').val(
          $("#numberofdesignsdropdown").val()
        );
      } else {
        $('.price_per_design_dpo .assist input[type="number"]').val(1);
      }

      if ($(".quantity__input").val() > 1) {
        $(".numberofdesignstep").removeClass("invisible");
      }
      $(".booking-section").removeClass("hide");
    } else {
      $("#require_design_services_hidden").val($(this).text());
    }

    $(".view_pp_templates").removeClass("disabled");
    $(".view_pp_templates").removeClass("hide");
    $(".view_pp_templates").addClass("initialized");

    // if(e.originalEvent !==undefined){
    //     createDraftOrder();
    // }
  });

  function add_to_cart() {
    console.log($("#add-to-cart-form").serialize());
    if (typeof window.dpoOptions != "undefined") {
      window.dpoOptions.addToCart(this, event);
    } else if (typeof window.tpObserver != "undefined") {
      window.tpObserver.addToCart(event);
    } else {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $("#add-to-cart-form").serialize(),
        success: function () {
          window.location.href = "/cart";
        },
        error: function () {
          alert("Sorry, something went wrong. Please try again");
        },
      });
    }
  }

  $("#skip_upload").on("click", function () {
    add_to_cart();
  });
  $("#skip_upload_files").on("click", function (e) {
    
    add_to_cart();
  });

  // Number of designs dropdown change event
  // $(document).on('change', '#numberofdesignsdropdown', function(e){
  //   e.preventDefault(true);

  //   //update hidden_no_design input field
  //   $(".hidden_no_design input").val($(this).val());
  //   $(".hidden_no_design input").prop('checked', true);
  //   $('.hidden_no_design select>option').attr('selected', false);
  //   $('.hidden_no_design select').val($('.hidden_no_design select>option:eq('+$(this).val()+')').attr("value"));
  //   $('.hidden_no_design select>option:eq('+$(this).val()+')').attr('selected', true);

  //   if($(this).val()>=1){
  //       $('.price_per_design_dpo input[type="number"]').val($(this).val());
  //   }
  //   window.dpoOptions.updatePrice();
  // });

  $(document).on("change", ".hidden_no_design select", function () {
    console.log("hidden no design trigger change");
  });

  $("#BackToTop").click(function (e) {
    $("html, body").animate({ scrollTop: $("#step_1").offset().top }, 1000);
    return true;
  });

  function disableAllFields() {
    $(
      ".requiredesignstep .option, .tear_bow_requiredesignstep .option ,#itoris_dynamicproductoptions div.control"
    ).addClass("disabled");
    $(
      "#numberofdesignsdropdown,.quantity__input, .single-option-selector"
    ).prop("disabled", true);
    $("#quote-first-message").addClass("hide");
  }

  function enableAllFields() {
    $("#quote-first-message").addClass("hide");
    $(
      ".requiredesignstep .option, .tear_bow_requiredesignstep .option ,#itoris_dynamicproductoptions div.control"
    ).removeClass("disabled");
    $(
      "#numberofdesignsdropdown,.quantity__input,.single-option-selector"
    ).removeAttr("disabled");
  }

  $("#quote_to_cart_btn").click(function () {
    $("#getQuoteForm").modal("hide");
    return add_to_cart();
  });

  let customeremail = "";

  $(document).on("click", ".optional-workflow-section-close", function (e) {
    $(this).closest(".optional-workflow-section").addClass("hide");
  $(".teardrop-bow-form-details").css("display", "block");
  });

  function pitch_call() {
    const PITCH_APIKEY = "info-3477.myshopify.com";
    const PITCH_SECRETKEY = "secr_ihtr&nIjIQE)0XohMhfEHxrBxys78w";

    function generateSignature() {
      const timestamp = Math.floor(Date.now() / 1000);
      const signature = md5(PITCH_APIKEY + PITCH_SECRETKEY + timestamp);
      return { timestamp, apiKey: PITCH_APIKEY, signature };
    }

    function md5(str) {
      return CryptoJS.MD5(str).toString();
    }

    const url = "https://api.pitchprint.io/runtime/fetch-designs";
    const opts = generateSignature();
    opts.categoryId = "e8bcf2b28cceeb7e1f9797837a2771a2";

    $.ajax({
      url: url,
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(opts),
      success: function (result) {
        console.log(result);
        //let data = JSON.parse(result);
        let designs = result.data.items;

        designs.sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });

        console.log("designs:", designs.length);

        $(".pp-designs-wrapper").pagination({
          dataSource: designs,
          pageSize: 8,
          callback: function (data, pagination) {
            var title = $("#productSelect option:selected").html();
            var html = data;
            $(".pp-designs-wrapper .items").html(html);
            data.forEach(function (d) {
              let previewImg = d.previews[0];
              $(".pp-designs-wrapper .items").append(
                '<div class="pitchprint_design" design-id="' +
                  d.id +
                  '"><div class="pp-design-overlay"></div><img class="lazy2" src="' +
                  previewImg +
                  '" alt="' +
                  title +
                  '"/><a href="#" class="customize_design">Customise</a></div>'
              );
            });
          },
        });
        console.log("pagina again");
        // $("img.lazyload").lazyload();
      },
      error: function (xhr, status, error) {
        console.error("Error:", error);
      },
    });
  }

  function getPPDesignPreviewImages(catId) {
    if (
      $("#hidden_meta_print_read_artwork_options").val().indexOf("own") != -1
    ) {
      console.log("getPPDesignPreviewImages");
      if (catId == undefined) {
        catId = $("#pp_design_cat_hidden_id").val();
      }
      if (catId.includes("pp-cat-")) {
        catId = catId.substr(7);
      }
      let data = {
        category_id: catId,
      };
      $(".pp-designs-wrapper .items").html("");
      $(".pp-designs-wrapper .pager .pageNumbers").html("");

      $.ajax({
        method: "POST",
        url: "https://phpstack-321644-985620.cloudwaysapps.com/pitchprint-design.php",
        data: data,

        success: function (result) {
          let data = JSON.parse(result);
          let designs = data.data.items;

          designs.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          });

          console.log("designs:", designs.length);

          $(".pp-designs-wrapper").pagination({
            dataSource: designs,
            pageSize: 8,
            callback: function (data, pagination) {
              var title = $("#productSelect option:selected").html();
              var html = data;
              $(".pp-designs-wrapper .items").html(html);
              data.forEach(function (d) {
                let previewImg = d.previews[0];
                $(".pp-designs-wrapper .items").append(
                  '<div class="pitchprint_design" design-id="' +
                    d.id +
                    '"><div class="pp-design-overlay"></div><img class="lazy2" data-src="' +
                    previewImg +
                    '" alt="' +
                    title +
                    '"/><a href="#" class="customize_design">Customise</a></div>'
                );
              });
            },
          });
          console.log("pagina again");
          // $("img.lazyload").lazyload();
        },
      });
    } else {
      console.log("getPPDesignPreviewImages no own");
    }
  }

  $("#modal-addtocart").on("click", function () {
    $(this).prop("disabled", true);
    window.localStorage.setItem("pprint-sp", JSON.stringify([]));
    window.localStorage.setItem("pprint-projects", JSON.stringify({}));
    $(".modal_loading").removeClass("hide");
    $(this).find("svg").attr("class", "loading-svg");
    return add_to_cart();
  });
  $("#gobackto-editor").on("click", function () {
    $("#pp-design-preview-modal").attr("goback", "true");
    $("#pp-design-preview-modal").modal("hide");
    $("#pp-designs-section").removeClass("hide");
    window.ppclient.showApp();
  });

  function updateProductMiniDetail() {
    $("#product-mini-detail .config-list").html("");
    $("#product-mini-detail .config-list").append(
      '<div class="config-list__item">Quantity : <strong>' +
        $(".quantity__input").val() +
        "</strong></div>"
    );
    $(".selector-wrapper.swhidden").each(function () {
      let fieldLabel = $(this).find("label").html();
      if (fieldLabel == undefined) {
        fieldLabel = "";
      }
      let fieldValue = $(this).find("select option:selected").html();
      let optionHTML =
        '<div class="config-list__item"' +
        fieldLabel +
        " : <strong>" +
        fieldValue +
        "</strong></div>";
      $("#product-mini-detail .config-list").append(optionHTML);
    });
    let dpoValues = dpoOptions.getAllOptionValues();
    dpoValues.forEach(function (value) {
      let optionHTML = "";
      if (Array.isArray(value.value)) {
        let valString = value.value
          .map(function (d) {
            return d.title;
          })
          .join(",");
        optionHTML =
          '<div class="config-list__item">' +
          value.title +
          " : <strong>" +
          valString +
          "</strong></div>";
      } else {
        optionHTML =
          '<div class="config-list__item">' +
          value.title +
          " : <strong>" +
          value.value +
          "</strong></div>";
      }
      $("#product-mini-detail .config-list").append(optionHTML);
    });
    let totalPrice = $("#totalPrice").html();
    $("#product-mini-detail .total--price").html(totalPrice);
  }

  function projectSaved(_val) {
    $("#pp-design-preview-modal").show();
    let _data = _val.data,
      _previewDiv = document.getElementById("pp_preview_div");
    $("#pp_preview_div").html("");
    let pId = _data.projectId;
    $("#hidden_property_saved_project_id").val(pId);
    $("#pitchprint_preview_pdf").val("https://pdf.pitchprint.io?id=" + pId);
    if (_data && _data.previews && _data.previews.length) {
      let cuTime = new Date().getTime();
      _previewDiv.innerHTML = _data.previews.reduce(
        (_str, _prev) => `${_str}<img src="${_prev}?${cuTime}">`,
        ""
      ); //Show the preview images
    }
    $("#pitchprint_preview_hidden").val($("#pp_preview_div img").attr("src"));

    $(".selected-options-list").html("");
    $(".selector-wrapper.swhidden").each(function () {
      let fieldLabel = $(this).find("label").html();
      if (fieldLabel == undefined) {
        fieldLabel = "";
      }
      let fieldValue = $(this).find("select option:selected").html();
      let optionHTML =
        '<div class="selected-option"><span class="selected-option-label">' +
        fieldLabel +
        '</span><span class="selected-option-value">' +
        fieldValue +
        "</span></div>";
      $(".selected-options-list").append(optionHTML);
    });
    let dpoValues = dpoOptions.getAllOptionValues();
    dpoValues.forEach(function (value) {
      if (value.title) {
        if (
          !value.title.includes("Calendly event") &&
          !value.title.includes("Price per design")
        ) {
          let optionHTML = "";
          if (Array.isArray(value.value)) {
            let valString = value.value
              .map(function (d) {
                return d.title;
              })
              .join(",");
            optionHTML =
              '<div class="selected-option"><span class="selected-option-label">' +
              value.title +
              '</span><span class="selected-option-value">' +
              valString +
              "</span></div>";
          } else {
            optionHTML =
              '<div class="selected-option"><span class="selected-option-label">' +
              value.title +
              '</span><span class="selected-option-value">' +
              value.value +
              "</span></div>";
          }
          $(".selected-options-list").append(optionHTML);
        }
      }
    });
    $("#selected-qty-option .selected-option-value").html(
      $(".quantity__input").val()
    );
    let totalPrice = $("#totalPrice").html();
    $(".selected-options-list").append(
      '<div class="selected-option"><span class="selected-option-label">Total</span><span class="selected-option-value">' +
        totalPrice +
        "</span></div>"
    );
    window.dpoOptions.updatePrice();
    $(".approveDesignProof__download").attr(
      "href",
      "https://pdf.pitchprint.io?id=" + pId
    );
    $("#pp-design-preview-modal").attr("goback", "false");
    $("#pp-design-preview-modal").modal("show");
    $("#pp-designs-section").addClass("hide");
  }
  window.ppDesignerInitialized = function (_class) {
    ppclient.on("project-saved", projectSaved);
    ppclient.on("editor-shown", function () {
      $("#pp-design-editor iframe:first-child").css(
        "max-height",
        $(window).height()
      );
      $("#pp-design-editor iframe:first-child").css(
        "height",
        $(window).height()
      );

      let sizeOptionText = $(".popular select option:selected").html();
      if (sizeOptionText != undefined) {
        if (sizeOptionText.includes("Custom")) {
          let productWidth = parseInt($(".custom-box.width input").val());
          let productHeight = parseInt($(".custom-box.height input").val());
          console.log("size-custom-here", productWidth, productHeight);
          window.ppclient.fire("resize-page", {
            width: productWidth,
            height: productHeight,
          });
        }
      }
    });
    ppclient.on("before-show", function () {
      $(".design-editor-loading").addClass("hide");
      let sizeOptionText = $(".popular select option:selected").html();
      if (sizeOptionText != undefined) {
        if (sizeOptionText.includes("Custom")) {
          let productWidth = parseInt($(".custom-box.width input").val());
          let productHeight = parseInt($(".custom-box.height input").val());
          console.log("size-custom-here", productWidth, productHeight);
          window.ppclient.fire("resize-page", {
            width: productWidth,
            height: productHeight,
          });
        }
      }
    });
    ppclient.on("design-loaded", function () {
      let sizeOptionText = $(".popular select option:selected").html();
      if (sizeOptionText != undefined) {
        if (sizeOptionText.includes("Custom")) {
          let productWidth = parseInt($(".custom-box.width input").val());
          let productHeight = parseInt($(".custom-box.height input").val());
          window.ppclient.fire("resize-page", {
            width: productWidth,
            height: productHeight,
          });
        }
      }
    });
  };
  $("#getQuoteWithDesignForm").on("hidden.bs.modal", function (e) {
    $("#pp-design-preview-modal").attr("goback", "true");
    $("#pp-designs-section").removeClass("hide");
    window.ppclient.showApp();
  });
  $("#pp-design-preview-modal").on("hidden.bs.modal", function (e) {
    if ($("#pp-design-preview-modal").attr("goback") != "true") {
      $("#pp-design-preview-modal").attr("goback", "true");
      $("#pp-designs-section").removeClass("hide");
      window.ppclient.showApp();
    }
  });

  $("#scroll-up-buy-more").on("click", function (e) {
    e.preventDefault(true);
    var y = $("#itier_prices").scrollTop(); // current page position
    $("#itier_prices").scrollTop(y - 25); // scroll up 150px
  });

  $("#scroll-down-buy-more").on("click", function (e) {
    e.preventDefault(true);
    var y = $("#itier_prices").scrollTop(); // current page position
    $("#itier_prices").scrollTop(y + 25);
  });

  $(".itier_price.selectable").on("click", function (e) {
    console.log("aaaa");
    $(".itier_price.selectable").removeClass("selected");
    $(this).addClass("selected");
  });
  let galleryWrapperWidth = $("#product-gallery-wrapper").width();

  $(document).on("change", ".single-option-selector, .select", function (e) {
    $("#productSelect").trigger("change");
    setTimeout(function () {
      let attachmentSelector =
        "#advance_attachment_" + $("#productSelect").val();
      let fileVal = $(attachmentSelector).val();
      if (fileVal != undefined) {
        $("#file_attachment").val(fileVal);
      }

      let widthSelector = "#standardized_width_" + $("#productSelect").val();
      let widthVal = $(widthSelector).val();
      if (widthVal != undefined) {
        $("#hidden_property_standardized_width").val(widthVal);
      }
      let widthSelector2 =
        "#standardized_width_external_" + $("#productSelect").val();

      let widthVal2 = $(widthSelector2).val();

      if (widthVal2 != undefined) {
        $("#hidden_property_standardized_width_external").val(widthVal2);
      }
      let heightSelector = "#standardized_height_" + $("#productSelect").val();
      let heightVal = $(heightSelector).val();
      if (heightVal != undefined) {
        $("#hidden_property_standardized_height").val(heightVal);
      }

      let sidedSelector = "#standardized_sided_" + $("#productSelect").val();
      let sidedVal = $(sidedSelector).val();
      if (sidedVal != undefined) {
        $("#hidden_property_standardized_sided").val(sidedVal);
      } else {
        $("#hidden_property_standardized_sided").val("Single");
      }

      let materialSelector =
        "#standardized_material_" + $("#productSelect").val();
      let materialVal = $(materialSelector).val();
      if (materialVal != undefined) {
        $("#hidden_property_standardized_material").val(materialVal);
      }

      let rollSizeSelector =
        "#standardized_roll_size_" + $("#productSelect").val();
      let rollSizeVal = $(rollSizeSelector).val();
      if (rollSizeVal != undefined) {
        $("#hidden_property_standardized_roll_size").val(rollSizeVal);
      }

      let TemplateSelector = "#template_name_" + $("#productSelect").val();
      let TemplateName = $(TemplateSelector).val();
      if (TemplateName != undefined) {
        $("#hidden_template_name").val(TemplateName);
      }

      let ProductMaterialSelector =
        "#sides_print_material_" + $("#productSelect").val();
      let ProductVariantMaterialSelector = $(ProductMaterialSelector).val();
      if (ProductVariantMaterialSelector != undefined) {
        $("#variant_product_material").val(ProductVariantMaterialSelector);
      }

      let TemplateUrlSelector = "#template_link_" + $("#productSelect").val();
      let TemplateFileUrl = $(TemplateUrlSelector).val();
      if (TemplateFileUrl != undefined) {
        $("#hidden_template_file_link").val(TemplateFileUrl);
      }

      let PrintingSelector = "#backside_printing_" + $("#productSelect").val();
      let BackSidePrint = $(PrintingSelector).val();
      if (BackSidePrint != undefined) {
        $("#hidden_backside_printing").val(BackSidePrint);
      }

      let PrintingPageSelector = "#printing_pages_" + $("#productSelect").val();
      let PrintPages = $(PrintingPageSelector).val();
      if (PrintPages != undefined) {
        $("#hidden_printing_pages").val(PrintPages);
      }

      if ($("#hidden_json_standardized_data").val() != undefined) {
        let standardized_data = JSON.parse(
          $("#hidden_json_standardized_data").val()
        );
        if (
          typeof standardized_data[$("#productSelect").val()] != "undefined"
        ) {
          let currentVariant = standardized_data[$("#productSelect").val()];
          $("#hidden_property_standardized_sided").val(currentVariant["sided"]);
          $("#hidden_property_standardized_width").val(currentVariant["width"]);
          $("#hidden_property_standardized_height").val(
            currentVariant["height"]
          );
        }
      }

      if (e.originalEvent !== undefined) {
        let ppcatSelector = "#ppcatid-" + $("#productSelect").val();

        let pitchprint_catid = $(ppcatSelector).val();
        if (pitchprint_catid != undefined) {
          if (pitchprint_catid.includes("pp-cat-")) {
            pitchprint_catid = pitchprint_catid.substr(7);
            console.log(pitchprint_catid);
          }
          $("#pp_design_cat_hidden_id").val(pitchprint_catid);
          getPPDesignPreviewImages();
        }
      }
    }, 100);
  });

  $("#design-idea-textarea").on("keydown", function () {
    if ($(this).val() != "") {
      $("#continue_cart").removeClass("hide");
    }
  });

  $(document).on("change keyup", "textarea.uploadkit-textarea", function () {
    var invalidChars = /[^0-9]/gi;
    if (invalidChars.test($(this).val())) {
      $(this).val("");
    } else {
      let sum = 0;

      $("textarea.uploadkit-textarea").each(function () {
        if (!isNaN(parseInt($(this).val()))) {
          sum += parseInt($(this).val());
        }
      });
      if (!isNaN(parseInt($(".quantity__input").val()))) {
        if (sum > $(".quantity__input").val()) {
          if (!$(".uploadkit-thumbnails .err-msg").length) {
            $(".uploadkit-thumbnails").append(
              '<p class="err-msg">Total number of designs ordered = ' +
                $(".quantity__input").val() +
                "</p>"
            );
            setTimeout(function () {
              $(".uploadkit-thumbnails p.err-msg").remove();
            }, 5000);
          }
          $(this).val("");
        }
      } else {
        if (sum > 1) {
          if (!$(".uploadkit-thumbnails .err-msg").length) {
            $(".uploadkit-thumbnails").append(
              '<p class="err-msg">Total number of designs ordered = 1</p>'
            );
            setTimeout(function () {
              $(".uploadkit-thumbnails p.err-msg").remove();
            }, 5000);
          }
          $(this).val("");
        }
      }
    }
  });

  $("input[type='radio'][name='schedule_meeting']").on("change", function () {
    if ($(this).val() == "yes") {
      console.log("yes");
      $(".dpo_meeting_option .choice input").prop("checked", false);
      $(".dpo_meeting_option .choice.yes input").prop("checked", true);
      window.dpoOptions.updatePrice();
      if ($("#hidden_meeting_scheduled").val() != "scheduled") {
        $(".calendly-badge-content").trigger("click");
      }
    } else {
      console.log("no");
      $(".dpo_meeting_option .choice input").prop("checked", false);
      $(".dpo_meeting_option .choice.no input").prop("checked", true);
      window.dpoOptions.updatePrice();
    }
  });
  function isCalendlyEvent(e) {
    return e.data.event && e.data.event.indexOf("calendly") === 0;
  }

  window.addEventListener("message", function (e) {
    if (isCalendlyEvent(e)) {
      if (e.data.event == "calendly.event_scheduled") {
        $("#hidden_property_confirmed_meeting").val("Meeting Confirmed");
        $("#schedule_meeting + strong").html(
          "let's schedule time to review online (Appointment Confirmed Details Emailed)"
        );
        $(".calendly-popup-close").trigger("click");
        $("#hidden_meeting_scheduled").val("scheduled");
      }
    }
  });

  $("#get_quote_with_design_btn").on("click", function () {
    if ($("#get_quote_design_customer_email").val() != "") {
      let priceArray = window.dpoOptions.updatePrice();
      var data = {
        email: $("#get_quote_design_customer_email").val(),
        variant_id: $("#productSelect option:selected").val(),
        title: $("#hidden_product_title").val(),
        qty: $(".quantity__input").val(),
        price: priceArray["current_prices"]["price"],
        variant_title: $("#productSelect option:selected").html(),
        require_design: $("#require_design_services_hidden").val(),
        delivery_option: $("#delivery_options_hidden").val(),
        product_image: $("#hidden_product_img").val(),
        custom_product: custom_size_box,
        project_id: $("#hidden_property_saved_project_id").val(),
        options: window.dpoOptions.getAllOptionValues(),
        standardized_width: $("#hidden_property_standardized_width").val(),
        standardized_height: $("#hidden_property_standardized_height").val(),
        variantOptions: product.options,
        product_url: window.location.href,
        product_id: product.id,
      };
      $.ajax({
        method: "POST",
        url: "https://phpstack-321644-985620.cloudwaysapps.com/Email-Design.php",
        data: data,
        success: function (result) {
          $("#getQuoteWithDesignForm").modal("hide");
        },
      });
    }
  });

  function approveDesign() {
    $("#modal-addtocart").show();
    $("#approve-design,#gobackto-editor").hide();
    $("#email-design,#customer-email").hide();
  }

  $("#email-design").on("click", function () {
    $("#pp-design-preview-modal").modal("hide");
    $("#pp-design-preview-modal").attr("goback", "true");
    $("#getQuoteWithDesignForm").modal("show");
  });

  function createDraftOrder() {
    let product = $("#product_json").val();
    if (window.dpoOptions) {
      let autoQuoteEmail = "";

      let priceArray = window.dpoOptions.updatePrice();

      autoQuoteEmail = "noemail";

      autoQuoteEmail = autoQuoteEmail.replace(/\s/g, "");
      var data = {
        email: autoQuoteEmail,
        variant_id: $("#productSelect option:selected").val(),
        // "title":product.title,
        // "title":$("#hidden_product_title").val(),
        title: $("#hidden_product_title").val(),
        qty: $(".quantity__input").val(),
        price: priceArray["current_prices"]["price"],
        variant_title: $("#productSelect option:selected").html(),
        require_design: $("#require_design_services_hidden").val(),
        delivery_option: $("#delivery_options_hidden").val(),
        // "product_image":product.featured_image,
        product_image: $("#hidden_product_img").val(),
        //"product_image":$("#hidden_product_img").val(),
        custom_product: custom_size_box,
        options: window.dpoOptions.getAllOptionValues(),
        variantOptions: product.options,
        standardized_width: $("#hidden_property_standardized_width").val(),
        standardized_height: $("#hidden_property_standardized_height").val(),
        product_url: window.location.href,
        product_id: product.id,
      };
      $.ajax({
        method: "POST",
        url: "https://phpstack-321644-985620.cloudwaysapps.com/Quote.php",
        data: data,

        success: function (result) {
          if (result == "Email has sent successfully.") {
            console.log("draft order has been created");
          } else {
            console.log("something went wrong");
          }
        },
      });
    }
  }

  // trigger after DPO price update
  jQuery(window).on("dpoPriceUpdate", function (e, o) {
    console.log("dpoPriceUpdate");
    jQuery("#totalPrice").html(
      dpoOptions.formatPrice(
        o.current_prices.price * $(".quantity__input").val()
      )
    );
    jQuery("#hidden_unit_price").val(o.current_prices.price);
    if ($(".quantity__input").val() > 1) {
      let is_modal_show = localStorage.getItem("alreadyShow");
      if (is_modal_show != "alredy shown") {
        $("#multiple-designs").show();
        localStorage.setItem("alreadyShow", "alredy shown");
      } else {
        console.log(is_modal_show);
      }
    }

    $(".itier_price.selectable").each(function () {
      if ($(".quantity__input").val() == $(this).attr("qty")) {
        $(".itier_price.selectable").removeClass("selected");
        $(this).addClass("selected");
        var y = $(this).position().top;
        $("#itier_prices").scrollTop(y); // scroll up 150px
      }
    });
  });
  /* send request to custom php app for draft order */
  $("#get_quote_form_btn").click(function () {
    var product = $("#product_json").val();
    // console.log(JSON.stringify(product));
    let priceArray = window.dpoOptions.updatePrice();

    var data = {
      email: $("#get_quote_customer_email").val(),
      variant_id: $("#productSelect option:selected").val(),
      // "title":product.title,
      title: $("#hidden_product_title").val(),
      qty: $(".quantity__input").val(),
      price: priceArray["current_prices"]["price"],
      variant_title: $("#productSelect option:selected").html(),
      require_design: $("#require_design_services_hidden").val(),
      delivery_option: $("#delivery_options_hidden").val(),
      //"product_image":product.featured_image,
      product_image: $("#hidden_product_img").val(),
      custom_product: custom_size_box,
      options: window.dpoOptions.getAllOptionValues(),
      standardized_width: $("#hidden_property_standardized_width").val(),
      standardized_height: $("#hidden_property_standardized_height").val(),
      variantOptions: product.options,
      product_url: window.location.href,
      product_id: product.id,
    };

    $.ajax({
      method: "POST",
      url: "https://phpstack-321644-985620.cloudwaysapps.com/Quote.php",
      data: data,

      success: function (result) {
        if (result == "Email has sent successfully.") {
          $(".thankyou-message").removeClass("hide");
          $("#getQuoteForm .modal-header h3").html("Thank you!");
          $(".form-first").addClass("hide");
        } else {
          $(".form-first").addClass("hide");
          $(".error-message").removeClass("hide");
        }
        $("#quote_close_btn").addClass("hide");
        $("#get_quote_form_btn").addClass("hide");
        $("#continue_shopping_btn").removeClass("hide");
        $("#quote_to_cart_btn").removeClass("hide");
      },
    });
  });

  $("#continue_to_design").on("click", function () {
    $("#numberofdesignsdropdown").val(1);
    $("#numberofdesignsdropdown").trigger("change");
    $(".hidden_no_design input").val(1);
  });

  $("#not_use_editor").on("click", function () {
    $("#design_exist").trigger("click");
  });
  /* email options  till qty */
  $("#get_options").click(function () {
    let product_title = $("#hidden_product_title").val();
    let priceArray = window.dpoOptions.updatePrice();
    var data = {
      email: $("#quote_customer_email").val(),
      variant_id: $("#productSelect option:selected").val(),
      title:
        product_title +
        "-" +
        $("#productSelect option:selected").attr("data-sku"),
      qty: $(".quantity__input").val(),
      price: priceArray["current_prices"]["price"],
      variant_title: $("#productSelect option:selected").html(),
      //"product_image":product.featured_image,
      product_image: $("#hidden_product_img").val(),
      custom_product: custom_size_box,
      options: window.dpoOptions.getAllOptionValues(),
      product_url: window.location.href,
    };
    $.ajax({
      method: "POST",
      url: "https://phpstack-321644-985620.cloudwaysapps.com/Quote-options.php",
      data: data,

      success: function (result) {
        if (result == "Email has sent successfully.") {
          $(".thankyou-message").removeClass("hide");
          $(".form-first").addClass("hide");
        } else {
          $(".form-first").addClass("hide");
          $(".error-message").removeClass("hide");
        }
        $("#quote_close_btn").addClass("hide");
        $("#get_quote_form_btn").addClass("hide");
        $("#continue_shopping_btn").removeClass("hide");
        $("#quote_to_cart_btn").removeClass("hide");
      },
    });
  });
  $(document).on("click", ".customize_design", function (e) {
    e.preventDefault();
    if (
      $("#require_design_services_hidden").val() ==
      "Online design from templates"
    ) {
      $("#pp-design-editor").removeClass("hide");
      $(".design-editor-loading").removeClass("hide");
      let designId = $(this).closest(".pitchprint_design").attr("design-id");
      window.ppclient.closeApp();
      window.ppclient = new PitchPrintClient({
        apiKey: "info-3477.myshopify.com",
        designId: designId,
        custom: true,
      });
      window.ppclient.showApp();
      let varintId = $("#productSelect").val();
      let hiddenVariantSizeSelector = "#variant_size_" + varintId;
      if (custom_size_box == "") {
        if ($(hiddenVariantSizeSelector).val() != undefined) {
          let productSize = $(hiddenVariantSizeSelector).val().split("x");
          ppclient.fire("resize-page", { width: 120, height: 100 });
        }
      } else {
        let sizeHtml = $(".popular select option:selected").html();
        if (sizeHtml.includes("x")) {
          let productSize = sizeHtml.split("x");
        } else {
          let productWidth = parseInt($(".custom-box.width input").val());
          let productHeight = parseInt($(".custom-box.height input").val());
          if (productWidth != "" && productHeight != "") {
            ppclient.fire("resize-page", {
              width: productWidth,
              height: productHeight,
            });
          }
        }
      }
      updateProductMiniDetail();

      if ($("#pp-design-editor").height() > 0) {
        $("html, body").animate(
          { scrollTop: $("#pp-design-editor").offset().top },
          1000
        );
      }
    } else {
      //  $("html, body").animate({ scrollTop: $("#product-description-container").offset().top }, 1000);
    }
  });

  $(".quantity__input").on("keyup change", function (e) {
    if ($(this).val() == 1) {
      $("#multiple-designs").hide();
    }

    $(".itier_price.selectable").each(function () {
      if ($(".quantity__input").val() == $(this).attr("qty")) {
        $(".itier_price.selectable").removeClass("selected");
        $(this).addClass("selected");
        // $("#multiple-designs").hide();
      }
    });

    if (e.originalEvent !== undefined) {
      createDraftOrder();
      if (typeof window.dpoOptions != "undefined") {
        window.dpoOptions.updatePrice();
      }
    }
  });

  let pitchprint_catid = $("#hidden_meta_pitchprint_category_id").val();
  //     $(".view_pp_templates:not(.clicked)").click(function(){

  //       $("html, body").animate({ scrollTop: $(".optional-workflow-section.activesection").offset().top }, 50);
  // });
  $(document).on("click", ".view_pp_templates:not(.clicked)", function (e) {
    // setTimeout(function () {
    //   $("html, body").animate(
    //     {
    //       scrollTop: $(".optional-workflow-section.activesection").offset().top,
    //     },
    //     1000
    //   );
    // }, 2000);
    $(".variant-details-container").hide();
    $(".product_upload_file").show();
  });
  $(document).on("click", ".view_pp_templates", function (e) {
    e.preventDefault(true);
    if ($("#design_own_option").hasClass("clicked")) {
      pitch_call();
    }
    if (
      $(".quantity__input").val() == undefined ||
      $(".quantity__input").val() == ""
    ) {
      $(".quantity__input").val(1);
    }
    $(".activesection").removeClass("hide");
    $(this).addClass("clicked");
    // $("html, body").animate({ scrollTop: $(".requiredesignstep").offset().top - 5 }, 1000);
    $("html, body").animate(
      { scrollTop: $(".optional-workflow-section.activesection").offset().top },
      1000
    );
  });

  if (pitchprint_catid != undefined && pitchprint_catid != "") {
    console.log("category_id", pitchprint_catid);
    $(".pp-designs-wrapper .items").html("");
    let data = {
      category_id: pitchprint_catid,
    };
    $.ajax({
      method: "POST",
      url: "https://phpstack-321644-985620.cloudwaysapps.com/pitchprint-design.php",
      data: data,

      success: function (result) {
        let data = JSON.parse(result);
        let designs = data.data.items;
        if (designs != undefined) {
          designs.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          });
          console.log("designs:", designs.length);
          $(".pp-designs-wrapper").pagination({
            dataSource: designs,
            pageSize: 8,
            callback: function (data, pagination) {
              var html = data;
              $(".pp-designs-wrapper .items").html(html);
              var title = $("#productSelect option:selected").html();
              data.forEach(function (d) {
                let previewImg = d.previews[0];
                $(".pp-designs-wrapper .items").append(
                  '<div class="pitchprint_design" design-id="' +
                    d.id +
                    '"><div class="pp-design-overlay"></div><img src="' +
                    previewImg +
                    '" alt="' +
                    title +
                    '"/><a href="#" class="customize_design">Customise</a></div>'
                );
              });
            },
          });
          // $("img.lazyload").lazyload();
        }
      },
    });
  }

  $(".requiredesignstep .option:first-child").trigger("click");

  //   let variations = product.variants;

  //   let metafields = {};
  //   variations.forEach(function(d,i){
  //     if(i<=19){
  //     let tmp = {};
  //       let title = d.title;
  //       tmp['width'] = title.includes("A0")?"841":(title.includes("A1")?"594":(title.includes("A2")?"420":"297"));
  //     tmp['height'] = title.includes("A0")?"1188":(title.includes("A1")?"841":(title.includes("A2")?"594":"420"));
  //     tmp['sided'] = "Single";
  //     metafields[d['id']] = tmp;
  //     }
  //   });
  //   console.log(product.id);
  //   console.log(JSON.stringify(metafields));
});

// $( document ).ready(function() {
//   $('.continue--btn').hide();
//     $('.uploadcare--preview__done').click(function(){
//       $('#continue_cart').removeClass('hide');
//       $('#continue_cart').addClass('show');
//     });
// });

$("#pp-design-preview-modal button.close").on("click", function () {
  $("#pp-design-preview-modal").hide();
});

$(document).on("click", ".customize_design", function (e) {
  e.preventDefault();
  //  if($("#require_design_services_hidden").val()=="Online design from templates"){
  $("#pp-design-editor").removeClass("hide");
  $(".design-editor-loading").removeClass("hide");

  let designId = $(this).closest(".pitchprint_design").attr("design-id");
  window.ppclient.closeApp();
  window.ppclient = new PitchPrintClient({
    apiKey: "vividads-com-au.myshopify.com",
    designId: designId,
    custom: true,
  });
  window.ppclient.showApp();
  let varintId = $("#productSelect").val();
  let hiddenVariantSizeSelector = "#variant_size_" + varintId;
  if (custom_size_box == "") {
    if ($(hiddenVariantSizeSelector).val() != undefined) {
      let productSize = $(hiddenVariantSizeSelector).val().split("x");
      ppclient.fire("resize-page", { width: 120, height: 100 });
    }
  } else {
    let sizeHtml = $(".popular select option:selected").html();
    if (sizeHtml.includes("x")) {
      let productSize = sizeHtml.split("x");
    } else {
      let productWidth = parseInt($(".custom-box.width input").val());
      let productHeight = parseInt($(".custom-box.height input").val());
      if (productWidth != "" && productHeight != "") {
        ppclient.fire("resize-page", {
          width: productWidth,
          height: productHeight,
        });
      }
    }
  }
  updateProductMiniDetail();

  if ($("#pp-design-editor").height() > 0) {
    $("html, body").animate(
      { scrollTop: $("#pp-design-editor").offset().top },
      1000
    );
  }
  // }else{
  // //  $("html, body").animate({ scrollTop: $("#product-description-container").offset().top }, 1000);
  // }
});



// code by dhruv

document.addEventListener("DOMContentLoaded", function () {
    const options = document.querySelectorAll(".dropdown-options li");
    const quantityInput = document.querySelector(".input_quan");

    // Function to handle selecting an option
    function selectOption(li) {
        // Remove active class from all
        options.forEach(option => option.classList.remove("active"));
        
        // Add active class to selected
        li.classList.add("active");

        // Set input value
        const value = li.getAttribute("data-value");
        quantityInput.value = value;
    }

    // Attach click event listeners
    options.forEach(li => {
        li.addEventListener("click", function () {
            selectOption(li);
        });
    });

    // Select the first li by default
    if (options.length > 0) {
        selectOption(options[0]);
    }
});

// back to quoate 

jQuery(document).ready(function($) {
  $('.upload_later').on('click', function() {
    $('.teardrop-bow-form-details').css('display', 'block');
      $('.product_upload_file').css('display', 'none');
  });
});